// Single Roboto stack for the dashboards, applied to the shell container (cascades to all HTML),
// the Highcharts chart, and the shared tooltip so everything renders in the same font.
export const DASHBOARD_FONT_FAMILY = 'Roboto, "Helvetica Neue", "Helvetica", "Arial", sans-serif'
